import Schema from 'fn/Schema'

const schema = {
  type: 'object',
  properties: {
    name: { type: 'string' },
    at: {
      type: 'string',
      format: 'date-time'
    },
    level: {
      type: 'string',
      enum: [
        'low',
        'middle',
        'high'
      ]
    },
    head: { type: 'number' },
    tail: { type: 'number' }
  },
  required: [
    'name',
    'at',
    'level'
  ],
  additionalProperties: false
}

export default new Schema( schema )
